<template>
  <div class="container">
    <v-card>
      <v-toolbar class="mt-12" dark color="primary">
        <v-toolbar-title>Gestión de Jugadores</v-toolbar-title>
      </v-toolbar>

      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-chip label color="transparent" text-color="black">
                <h3>Búsqueda de Jugadores</h3>
              </v-chip>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="9" sm="6" md="4">
              <v-text-field
                v-model="dni"
                prepend-icon="mdi-account"
                label="D.N.I"
                dense
                required
                @keypress="onlyNumber"
                maxlength="9"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-text-field
                v-model="apellidos"
                prepend-icon="mdi-account"
                label="Apellidos"
                maxlength="50"
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-text-field
                v-model="nombres"
                prepend-icon="mdi-account"
                label="Nombres"
                maxlength="50"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
      <v-card-actions class="mt-0 pt-0">
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!valid || loading"
          :loading="loading"
          color="primary"
          @click.stop="handleBuscarPacientes"
        >
          Buscar
          <v-icon dark right>mdi-magnify</v-icon>
        </v-btn>
      </v-card-actions>

      <v-data-table
        v-show="listaPacientes.length"
        :headers="headers"
        :items="this.listaPacientes"
        class="elevation-1"
        locale="es-ar"
        :items-per-page="10"
        item-key="idPaciente"
        ref="myTable"
        disable-sort
        disable-filtering
        :server-items-length="cantRegistros"
        :footer-props="{
          itemsPerPageText: 'Jugadores por página',
          itemsPerPageOptions: [5, 10, 15],
        }"
        :options.sync="options"
        :loading="isLoading"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                color="purple"
                class="mr-3"
                v-on="on"
                v-bind="attrs"
                @click.stop="editarPaciente(item)"
                >mdi-pencil</v-icon
              >
            </template>
            <span>Editar Jugador</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                v-on="on"
                color="green"
                class="mr-3"
                v-bind="attrs"
                @click="caracteristicas(item)"
                >mdi-list-box</v-icon
              >
            </template>
            <span>Características Jugador</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                v-on="on"
                color="red"
                v-bind="attrs"
                @click="borrarPaciente(item)"
                >mdi-delete</v-icon
              >
            </template>
            <span>Eliminar Jugador</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-alert
        class="mt-4"
        color="purple"
        dark
        outlined
        v-if="!listaPacientes.length"
      >
        No hay jugadores que coincidan con los filtros de búsqueda.
      </v-alert>
      <v-card-actions class="paciente-acciones">
        <v-btn dark color="#24232d" @click="salir">
          <v-icon left>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" @click.stop="nuevoPaciente">Nuevo Jugador</v-btn>
        <v-btn
          color="warning"
          :disabled="listaPacientes.length < 1"
          @click.stop="imprimir"
          >Imprimir</v-btn
        >
        <v-btn color="primary" @click.stop="unificarFichas"
          >Unificar Fichas</v-btn
        >
      </v-card-actions>
      <NuevoJugador
        :visible="showNuevoPaciente"
        @close="cierraNuevoPaciente"
      ></NuevoJugador>
      <EditarJugador
        :visible="showEditarPaciente"
        :idPaciente="editedItem.idpaciente"
        :dniActual="editedItem.nrodocumento"
        @close="cierraEditarPaciente()"
        @pacienteModificado="pacienteModificado"
      ></EditarJugador>
      <CaracteristicasJugador
        :visible="showCaracteristicas"
        :idPaciente="editedItem.idpaciente"
        :nombrePaciente="editedItem.nombrePaciente"
        @close="cierraCaracteristicas()"
      ></CaracteristicasJugador>
      <UnificarFichas
        :visible="showUnificarFichas"
        @close="cierraUnificarFichas()"
        @fichasUnificadas="fichasUnificadas"
      />
    </v-card>
  </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
.paciente-acciones {
  flex-wrap: wrap;
  gap: 1rem;
}
.container {
  margin: auto;
}
</style>
<script>
import axios from "@/axios-auth";
import router from "@/router";
import jsPDF from "jspdf";
import autotable from "jspdf-autotable";
import UnificarFichas from "./UnificarFichas.vue";
import NuevoJugador from "@/components/Gestion/Jugadores/NuevoJugador.vue";
import EditarJugador from "@/components/Gestion/Jugadores/EditarJugador.vue";
import CaracteristicasJugador from "./CaracteristicasJugador.vue";
import { showAlert } from "@/utils/toast";
export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    esGestanteOptions: [
      { value: "todos", text: "TODOS" },
      { value: "gestante", text: "GESTANTE" },
      { value: "noGestante", text: "NO GESTANTE" },
    ],
    esGestante: "todos",
    esDiabeticoOptions: [
      { value: "todos", text: "TODOS" },
      { value: "diabetico", text: "DIABÉTICO" },
      { value: "noDiabetico", text: "NO DIABÉTICO" },
    ],
    esDiabetico: "todos",
    esEpocOptions: [
      { value: "todos", text: "TODOS" },
      { value: "epoc", text: "TIENE EPOC" },
      { value: "noEpoc", text: "NO TIENE EPOC" },
    ],
    esEpoc: "todos",
    esFumadorOptions: [
      { value: "todos", text: "TODOS" },
      { value: "fumador", text: "FUMADOR" },
      { value: "noFumador", text: "NO FUMADOR" },
    ],
    esFumador: "todos",
    esHtaOptions: [
      { value: "todos", text: "TODOS" },
      { value: "hta", text: "TIENE HTA" },
      { value: "noHta", text: "NO TIENE HTA" },
    ],
    esHta: "todos",
    esObesoOptions: [
      { value: "todos", text: "TODOS" },
      { value: "obeso", text: "TIENE OBESIDAD" },
      { value: "noObeso", text: "NO TIENE OBESIDAD" },
    ],
    esObeso: "todos",
    esRcvOptions: [
      { value: "todos", text: "TODOS" },
      { value: "rcv", text: "TIENE RCV > 20%" },
      { value: "noRcv", text: "NO TIENE RCV > 20%" },
    ],
    esRcv: "todos",
    esSobrePesoOptions: [
      { value: "todos", text: "TODOS" },
      { value: "sobrePeso", text: "TIENE SOBREPESO" },
      { value: "noSobrePeso", text: "NO TIENE SOBREPESO" },
    ],
    esSobrePeso: "todos",
    apellidos: null,
    nombres: null,
    dni: null,
    listaPacientes: [],
    headers: [
      { text: "D.N.I.", value: "nrodocumento" },
      { text: "Apellidos", value: "apellidos" },
      { text: "Nombres", value: "nombres" },
      { text: "Cel.", value: "celular" },
      { text: "Mail.", value: "email" },
      { text: "Acciones", value: "actions" },
    ],
    showNuevoPaciente: false,
    showEditarPaciente: false,
    showCaracteristicas: false,
    showUnificarFichas: false,
    editedItem: {},
    editedIndex: -1,
    loading: false,
    isLoading: false,
    options: {},
    cantRegistros: null,
  }),
  watch: {
    options: {
      immediate: true,
      deep: true,
      handler(val) {
        if (Object.keys(val).length) {
          this.buscarPacientes(1);
        }
      },
    },
  },
  methods: {
    salir() {
      router.push({ path: "/Home" });
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
    borrarPaciente(item) {
      this.$swal({
        title: "Borrar Jugador",
        text: "¿Desea borrar el jugador?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const idpaciente = item.idpaciente;
          let self = this;
          axios
            .get("/Paciente/BorrarPaciente?", {
              params: {
                idPaciente: idpaciente,
              },
            })
            .then((response) => {
              if (response.data == "error") {
                self.showAlert({
                  icon: "warning",
                  title: "El jugador tiene transacciones asociadas.",
                  vm: self,
                });
              } else {
                self.showAlert({
                  icon: "success",
                  title: "Jugador borrado exitosamente.",
                  vm: self,
                });
                setTimeout(self.buscarPacientes(0), 1700);
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "El Jugador no pudo ser borrado.",
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    cierraNuevoPaciente(data) {
      this.showNuevoPaciente = false;
      this.buscarPacientes(0);
      console.log('data', data);
      if (data && data.idpaciente) {
        this.$nextTick(() => {
          this.editedItem = {
            idpaciente: data.idpaciente,
            nombrePaciente: data.apellidos + ", " + data.nombres,
          };
          this.showCaracteristicas = true;
        });
      }
    },
    cierraEditarPaciente() {
      this.showEditarPaciente = false;
    },
    cierraCaracteristicas() {
      this.showCaracteristicas = false;
    },
    cierraUnificarFichas() {
      this.showUnificarFichas = false;
    },
    fichasUnificadas() {
      this.showUnificarFichas = false;
      this.buscarPacientes(0);
    },
    pacienteModificado() {
      this.showEditarPaciente = false;
      this.buscarPacientes(0);
    },
    caracteristicas(item) {
      this.editedIndex = this.listaPacientes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.nombrePaciente = item.apellidos + ", " + item.nombres;
      this.showCaracteristicas = true;
    },
    unificarFichas() {
      this.showUnificarFichas = true;
    },
    nuevoPaciente() {
      this.showNuevoPaciente = true;
    },
    editarPaciente(item) {
      this.editedIndex = this.listaPacientes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showEditarPaciente = true;
    },
    handleBuscarPacientes() {
      this.options.page = 1;
      this.buscarPacientes(1);
    },
    buscarPacientes(state) {
      const filtros = {
        dni: this.dni,
        apellidos: this.apellidos,
        nombres: this.nombres,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
        esGestante: "todos",
        esDiabetico: "todos",
        esEpoc: "todos",
        esFumador: "todos",
        esHta: "todos",
        esObeso: "todos",
        esRcv: "todos",
        esSobrePeso: "todos",
      };
      this.isLoading = true;
      let self = this;

      const filtrosData = {
        dni: filtros.dni,
        apellidos: filtros.apellidos,
        nombres: filtros.nombres,
        idInstitucion: filtros.idInstitucion,
        esGestante: filtros.esGestante,
        esDiabetico: filtros.esDiabetico,
        esEpoc: filtros.esEpoc,
        esFumador: filtros.esFumador,
        esHta: filtros.esHta,
        esObeso: filtros.esObeso,
        esRcv: filtros.esRcv,
        esSobrePeso: filtros.esSobrePeso,
        page: this.options.page,
        items: this.options.itemsPerPage,
      };

      axios
        .post("/Paciente/BuscarPacientes?", filtrosData)
        .then(function (response) {
          if (response.data != null && response.data != "") {
            self.listaPacientes = response.data.listaPacientes;
            self.cantRegistros = response.data.cantRegistros;
            self.isLoading = false;
          } else {
            self.listaPacientes = [];
            self.isLoading = false;
            if (state == 1) {
              self.showAlert({
                icon: "warning",
                title:
                  "No hay jugadores que coincidan con los filtros de búsqueda.",
                vm: self,
              });
            }
          }
        })
        .catch(function (error) {
          self.isLoading = false;
        });
    },
    async imprimir() {
      const {
        data: { listaPacientes = [] },
      } = await axios.post("/Paciente/BuscarPacientes?", {
        dni: this.dni,
        apellidos: this.apellidos,
        nombres: this.nombres,
        page: 1,
        items: 9999999,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
        esGestante: "todos",
        esDiabetico: "todos",
        esEpoc: "todos",
        esFumador: "todos",
        esHta: "todos",
        esObeso: "todos",
        esRcv: "todos",
        esSobrePeso: "todos",
      });
      let source = listaPacientes;
      let rows = [];
      let columnHeader = ["D.N.I.", "Apellidos", "Nombres", "Cel.", "Posición", "Categoría", "Brazo"];
      source.forEach((element) => {
        var temp = [
          element.nrodocumento,
          element.apellidos,
          element.nombres,
          element.celular,
          element.posicion || "",
          element.categoria || "",
          element.brazo || "",
        ];
        rows.push(temp);
      });
      var doc = new jsPDF("landscape");
      doc.setProperties({
        title: "Listado Jugadores",
      });
      var nombreInstitucion =
        this.$store.state.usuario.institucion.nombreInstitucion
          .toString()
          .trim();

      doc.setFontSize(12);
      doc.text(nombreInstitucion, 13, 10);
      doc.setFontSize(10);

      doc.setFontSize(16);
      doc.text(
        "Listado de Jugadores",
        doc.internal.pageSize.getWidth() / 2,
        33,
        { align: "center" },
      );
      doc.autoTable(columnHeader, rows, {
        startY: 39,
        didParseCell: function (table) {
          if (table.section === "head") {
            table.cell.styles.fillColor = "#c4c5c5";
          }
        },
      });

      window.open(doc.output("bloburl"), "_blank");
    },
  },

  mounted() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  },

  components: {
    NuevoJugador,
    EditarJugador,
    UnificarFichas,
    CaracteristicasJugador,
  },
};
</script>
